import { React } from "react";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PropTypes from "prop-types";

function Dropdown({ cssName, setSortBy, sortBy }) {
  // const [sortBy, setSortBy] = useState(0);
  const handleOrderBy = (event) => {
    setSortBy(event);
  };
  return (
    <div className="b-container-dropdown">
      <FormControl size="small" className={`b-container-dropdown__${cssName}`}>
        <InputLabel
          className="b-container-dropdown__inputlabel"
          id="demo-select-small"
          value={sortBy}
        />
        <Select
          className="font-bold"
          labelId="demo-select-small"
          id="demo-select-small"
          label=""
          value={sortBy}
          IconComponent={ArrowDropDownIcon}
          onChange={handleOrderBy}
        >
          <MenuItem className="font-bold" value={0}>
            Ascending
          </MenuItem>

          <MenuItem className="font-bold" value={1}>
            Descending
          </MenuItem>
        </Select>
      </FormControl>
    </div>
  );
}
Dropdown.propTypes = {
  // eslint-disable-next-line react/require-default-props
  cssName: PropTypes.string,
  sortBy: PropTypes.number.isRequired,
  setSortBy: PropTypes.func.isRequired,
};
export default Dropdown;
